'use strict';

// adapt the layout of the shared count criterium
// to look better with competitors

var putSidInArray = require('./putSidInArray');
var addTabsForSiComp = require('./addTabsForSiComp');
var addMainDataInSiComp = require('./addMainDataInSiComp');

function competizeSharedCount () {
  var dataLength;
  var id = 0;
  var $this = $(
    '#criterium-shared_count.criterium-have-comp:not(.is-competized)'
  );
  var $content = $this.find('>div.criterium-content');
  var $comp = $this.find('>div.competitor-content');
  var data = {};

  if ($this.length === 1 && $content.length === 1 && $comp.length > 0) {
    $this.addClass('is-competized');
    data = putSidInArray($content, data, 0);

    $comp.each(function () {
      var obj;
      obj = $(this);
      id++;
      data = putSidInArray(obj, data, id);
      return data;
    });

    dataLength = Object.keys(data).length;

    $comp.each(function () {
      var obj;
      obj = $(this);
      return addMainDataInSiComp(obj, data, dataLength);
    });

    addTabsForSiComp($content, data, dataLength);

    $content.addClass('hidden');
  }
}

module.exports = competizeSharedCount;
